var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.practica)?_c('div',{attrs:{"div":""}},[_c('Practica',{attrs:{"onBack":_vm.onBack,"practica":_vm.practica,"revision":true,"show_alumno":true,"alumno":_vm.practica.alumno}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }